<template lang="html">
  <section class="app-create-subscriber">
    <p class="text-success" v-if="messageSubmission">
      <strong>{{ messageSubmission }}</strong>
    </p>
    <form @submit.prevent="onSubmit" class=" text-left" :class="$v.dataForm.$invalid ? '':'was-validated'">
      <div class="form-group d-flex">
        <label for="subscriberEmail" class="w-25 align-self-center">* Email :</label>
        <div class="w-100">
          <input :class="$v.dataForm.subscriberEmail.$error ? 'is-invalid': ''" type="email"
                 @blur="$v.dataForm.subscriberEmail.$touch()" v-model="dataForm.subscriberEmail"
                 class="form-control" id="subscriberEmail" required>
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.subscriberEmail.required">You must absolutely enter an email address !</div>
            <div v-if="!$v.dataForm.subscriberEmail.email">Please enter a valid email address !</div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <div class="w-25 align-self-center">* Unsubscribed: </div>
        <div class="w-90">
          <div class="custom-control custom-radio custom-control-inline">
            <input v-model="dataForm.subscriberUnsubscribed" value="1" type="radio"
                   id="subsribedYes" class="custom-control-input">
            <label class="custom-control-label" for="subsribedYes">YES</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input v-model="dataForm.subscriberUnsubscribed" value="0" type="radio"
                   id="subsribedNo" class="custom-control-input">
            <label class="custom-control-label" for="subsribedNo">NO</label>
          </div>
        </div>
      </div>
      <div class="mt-4 mb-4 text-center">
        <button :class="$v.dataForm.$invalid ? 'cursor-pointer-disabled':''"
                type="submit" class="btn btn-success" :disabled="$v.dataForm.$invalid">
          Submit
        </button>
        <button type="button" class="btn btn-danger ml-3" @click="resetForm">
          Reset
        </button>
      </div>
    </form>
  </section>
</template>

<script lang="js">
import {mapActions} from "vuex";
import {FORM_SUBSCRIBERS_VALIDATIONS} from '../../validations/formSubscribers'

export default {
  name: 'CreateSubscriber',
  props: [],
  mounted () {},
  validations: FORM_SUBSCRIBERS_VALIDATIONS,
  data () {
    return {
      dataForm: {
        subscriberEmail: undefined,
        subscriberUnsubscribed: 0
      },
      messageSubmission: ""
    }
  },
  methods: {
    ...mapActions([
      'createData'
    ]),
    onSubmit () {
      const formData = {
        email: this.dataForm.subscriberEmail,
        unsubscribed: this.dataForm.subscriberUnsubscribed
      };
      this.createData(formData)
        .then(data => {
          this.messageSubmission = data;
          setTimeout( () => {
            this.messageSubmission = '';
            this.resetForm();
          }, 5000);
        })
        .catch(data => console.log(data))
    },
    resetForm () {
      this.dataForm.subscriberEmail = undefined;
      this.dataForm.subscriberUnsubscribed = 0;
    }
  },
  computed: {}
}
</script>

<style scoped lang="scss">
  .app-create-subscriber {}
</style>



// WEBPACK FOOTER //
// src/components/subscribers/CreateSubscriber.vue